$.ajax({
  url: '/collections/color?view=color-pictures.json',
  headers: {
      'Content-Type':'application/json'
  },
  method: 'GET',
  success: function(data){
    var colors_swatches = document.getElementsByClassName("product-card-colors__img");
    const colorUrls = JSON.parse(data);
    for (var i = 0; i < colors_swatches.length; i++) {
      colors_swatches[i].style = "background-image:url(" + colorUrls[colors_swatches[i].title] + ")";
    }
  }
});
